export const images = 

[
  {
    "src": "/images/KIDS/37.png",
    "Alt": "2",
    "id": 21
  },
  {
    "src": "/images/KIDS/38.png",
    "Alt": "2",
    "id": 22
  },
  {
    "src": "/images/KIDS/39.png",
    "Alt": "2",
    "id": 23
  },
  {
    "src": "/images/KIDS/41.png",
    "Alt": "2",
    "id": 24
  },

]